import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

export default register('quotes-carousel', {
  onLoad() {
    const slider = this.container.querySelector('.quotes-section__slider');
    if (!slider) return;

    // eslint-disable-next-line no-unused-vars
    const flickity = new Flickity(slider, {
      freeScroll: false,
      prevNextButtons: false,
      pageDots: true,
      contain: true,
    });
  },
});
